export default __webpack_public_path__ + "static/media/hair-4-7.563fa319.svg";